import { AppLogoProps, BrandingLogoProps, LinkProps, MainMenuItemProps } from '@msaf/core-react'
import AucklandCouncilLogo from '../assets/auckland-council-logo.png'
import OtagoRegionalCouncilLogo from '../assets/otago-regional-council-logo.png'
import TeUruKahikaLogo from '../assets/te-uru-kahika-logo.png'
import WaikatoRegionalCouncilLogo from '../assets/waikato-regional-council-logo.png'
import MarlboroughDistrictCouncilLogo from '../assets/marlborough-district-council-logo.png'
import AppFullLogo from '../assets/wells-logo-full.svg'
import AppIconLogo from '../assets/wells-logo-icon-only.svg'

// Full application name, used on landing page
export const APP_NAME = 'Wells Aotearoa New Zealand'

// Application logo details, used in NavPanel as well as landing page
export const APP_LOGO: AppLogoProps = {
  iconLogoImagePath: AppIconLogo,
  fullLogoImagePath: AppFullLogo,
  logoTextLine1: 'Wells',
  logoTextLine2: 'Aotearoa | NZ',
  altText: APP_NAME,
  icon: undefined,
}

// Logo used in map search
export const MAP_SEARCH_APP_LOGO = {
  ...APP_LOGO,
  logoTextLine1: '',
  logoTextLine2: '',
}

export interface CouncilBrandingLogo extends BrandingLogoProps {
  councilId?: number | string
}
// Council/org logos output below main menu links
// Add in a councilId as part of CouncilBrandingLogo interface - councilId is removed when a matching logo is found
// TODO Add more councils as they are onboarded
export const BRANDING_LOGOS: Array<CouncilBrandingLogo> = [
  {
    imagePath: AucklandCouncilLogo,
    altText: 'Auckland Council',
    councilId: 4,
  },
  {
    imagePath: WaikatoRegionalCouncilLogo,
    altText: 'Waikato Regional Council',
    councilId: 3,
  },
  {
    imagePath: OtagoRegionalCouncilLogo,
    altText: 'Otago Regional Council',
    councilId: 1,
  },
  {
    imagePath: MarlboroughDistrictCouncilLogo,
    altText: 'Marlborough District Council',
    councilId: 16,
  },
]

// Base Application Branding logo
export const BASE_BRANDING_LOGO: BrandingLogoProps = {
  imagePath: TeUruKahikaLogo,
  altText: 'Te Uru Kahika - Regional and Unitary Councils Aotearoa',
  logoLayout: 'wide-rectangle',
}

// Logos displayed in footer of landing page
export const FOOTER_LOGOS = [
  {
    imgPath: TeUruKahikaLogo,
    altText: 'Te Uru Kahika - Regional and Unitary Councils Aotearoa',
  },
]

// Breakpoint for switching between mobile/desktop navigation patterns
// Should match `tablet-landscape-up` mixin here: client/src/styles/1-mixins/_breakpoints.scss
export const NAVIGATION_BREAKPOINT = '900px'
export const MAP_NAVIGATION_BREAKPOINT = '600px'

export enum MenuLinks {
  LANDING = '/',
  DASHBOARD = '/dashboard',
  SEARCH = '/wells',
  ADMINISTRATION = '/admin/users',
  CONTACT_US = '/contact-us',
  HELP_CENTRE = '/help-centre',
}

export const MAIN_MENU_LINKS: MainMenuItemProps[] = [
  { path: MenuLinks.DASHBOARD, label: 'Dashboard', icon: 'dashboard', exact: true },
  { path: MenuLinks.SEARCH, label: 'Well search', icon: 'drop' },
  {
    label: 'Contact us',
    icon: 'phone',
    path: MenuLinks.CONTACT_US,
    isNewSection: true,
  },
  {
    label: 'Help centre',
    icon: 'question-mark-circle',
    path: MenuLinks.HELP_CENTRE,
  },
]

export const ADMIN_MAIN_MENU_LINK: MainMenuItemProps = {
  path: MenuLinks.ADMINISTRATION,
  label: 'Administration',
  icon: 'settings',
}

export const UNAUTHENTICATED_MAIN_MENU_LINKS: MainMenuItemProps[] = [
  {
    label: 'Home',
    icon: 'dashboard',
    path: MenuLinks.LANDING,
  },
  {
    label: 'Well search',
    icon: 'drop',
    path: MenuLinks.SEARCH,
  },
  {
    label: 'Contact us',
    icon: 'settings',
    path: MenuLinks.CONTACT_US,
    isNewSection: true,
  },
  {
    label: 'Help centre',
    icon: 'bookmark',
    path: MenuLinks.HELP_CENTRE,
  },
]

export const FOOTER_MENU_LINKS: LinkProps[] = [
  {
    label: 'Well search',
    path: MenuLinks.SEARCH,
  },
  {
    label: 'Contact us',
    path: MenuLinks.CONTACT_US,
  },
  {
    label: 'Help centre',
    path: MenuLinks.HELP_CENTRE,
  },
  // TODO: make these worky:
  {
    label: 'Terms of use',
    path: 'terms-of-use',
  },
  {
    label: 'Register',
    path: '/?register=true',
  },
  {
    label: 'Sign in',
    path: '/?login=true',
  },
]

export enum KeycloakActionType {
  SIGNIN = 'signin',
  LOGOUT = 'logout',
  REGISTER = 'register',
}

// Toast message default settings
export const TOAST_MESSAGE_AUTO_CLOSE = 20000

// Default number of page links visible before using next/prev controls
export const NUM_VISIBLE_PAGINATION_LINKS = 5

export enum WorkflowNavLabels {
  DETAILS = 'Details',
  CONSTRUCTION = 'Construction',
  GEOTHERMAL = 'Geothermal',
  LITHOLOGY = 'Lithology',
  WELLHEAD_SECURITY = 'Wellhead security',
  DRINKING_WATER_SUPPLY = 'Drinking water supply',
  AQUIFER = 'Aquifer',
  YIELD_DRAWDOWN_TESTS = 'Yield drawdown tests',
  AQUIFER_TESTS = 'Aquifer tests',
  DOCUMENTS = 'Documents',
  EXTERNAL_DOCUMENT_REFERENCES = 'External document references',
  SUMMARY = 'Summary',
  APPROVAL = 'Approval',
  SUBMISSION = 'Submission',
}
